/*global cms*/
import axios from 'axios'

const createMedia = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${cms.baseURL}/api/media`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

export { createMedia }